import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const YouthLeadersEventPlansConductionReports = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Youth leaders' event plans, conduction, reports" />
    </Box>
  );
};
